import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterLink, RouterOutlet } from '@angular/router';
import { filter, map, startWith } from 'rxjs';

const HIDDEN_FOOTER_ROUTES = ['/userlist', '/notificaciones', '/login'];

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterLink],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'autogestion-app';
  showFooter;

  constructor(private router: Router) {
    const shouldShowFooter = () => !HIDDEN_FOOTER_ROUTES.some((route) => this.router.url.startsWith(route));

    this.showFooter = this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(shouldShowFooter),
      startWith(shouldShowFooter())
    );
  }
}
